import { CourseMaterial } from "./coursesLoader.ts";
import { unknownPrintSource } from "../../../../common/features/asset/AssetCover.tsx";

export function getImageSource(material: CourseMaterial) {
  if (material.materialFormat === "print") {
    return unknownPrintSource;
  }
  return null;
}
